import { useDecaf } from '@decafhub/decaf-react';
import { Card, Col, Row, Statistic } from 'antd';
import React, { useEffect, useState } from 'react';
import Page from './Page';

export interface AboutPageProps {
  appName?: string;
  appVersion?: string;
  appDescription?: string;
  content?: React.ReactNode;
}

export default function PageAbout(props: AboutPageProps) {
  const { client } = useDecaf();
  const [versionCultproxy, setVersionCultproxy] = useState<string | undefined>(undefined);
  const [versionBarista, setVersionBarista] = useState<string | undefined>(undefined);
  const [versionEstate, setVersionEstate] = useState<string | undefined>(undefined);

  useEffect(() => {
    client.bare.get<{ version: string }>('/_cultproxy').then(({ data }) => setVersionCultproxy(data.version));
    client.barista.get<{ version: string }>('/version/').then(({ data }) => setVersionBarista(data.version));
    client.bare.get<string>('/apis/estate/version').then(({ data }) => setVersionEstate(data));
  }, [client]);

  return (
    <Page>
      <Row gutter={[16, 16]}>
        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 8 }} xxl={{ span: 6 }}>
          <Card variant="borderless">
            <Statistic title="Application Name" value={props.appName} />
          </Card>
        </Col>

        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 16 }} xxl={{ span: 18 }}>
          <Card variant="borderless">
            <Statistic title="Application Description" value={props.appDescription} />
          </Card>
        </Col>

        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 6 }} xxl={{ span: 6 }}>
          <Card variant="borderless">
            <Statistic title="Application Version" value={props.appVersion} prefix="v" />
          </Card>
        </Col>

        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 6 }} xxl={{ span: 6 }}>
          <Card variant="borderless">
            <Statistic title="DECAF Cultproxy Version" value={versionCultproxy} prefix="v" />
          </Card>
        </Col>

        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 6 }} xxl={{ span: 6 }}>
          <Card variant="borderless">
            <Statistic title="DECAF Barista Version" value={versionBarista} prefix="v" />
          </Card>
        </Col>

        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 6 }} xxl={{ span: 6 }}>
          <Card variant="borderless">
            <Statistic title="DECAF Estate Version" value={versionEstate} prefix="v" />
          </Card>
        </Col>

        <Col span={24}>{props.content}</Col>
      </Row>
    </Page>
  );
}
